import React from 'react';

import { Link } from 'react-router-dom';

import { LOGIN_PATH } from 'constants/routes';

import { Footer } from '../shared';

function SignUpFooter() {
  return (
    <Footer>
      <SignUpText />
    </Footer>
  );
}

export function SignUpText() {
  return (
    <>
      Already have a Safari Portal account?{' '}
      <span>
        <Link to={LOGIN_PATH} className="link">
          Log in
        </Link>{' '}
        now.
      </span>
    </>
  );
}

export default SignUpFooter;
